import { useMemoizedFn } from 'ahooks';
import { revxScrollTo } from 'utils/scroll';
import React from 'react';

type Props = {
  setScrollLoading: (loading: boolean) => void;
  latestCountRef: React.MutableRefObject<any>;
};

const useScrollDetailTab = ({ setScrollLoading, latestCountRef }: Props) => {
  return useMemoizedFn((e) => {
    setScrollLoading(true);
    setTimeout(() => {
      setScrollLoading(false);
      const height = latestCountRef.current?.height - 500 || 0;
      revxScrollTo(+e?.pageY + height, 10);
    }, 2000);
  });
};

export default useScrollDetailTab;
